import React, { useState } from 'react';
import { Tag, Copy, Check } from 'lucide-react';

export default function PromoBar() {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText('SAVE20');
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (_err) {
      // fallback - select-only no-op
    }
  };

  return (
    <div className="bg-gradient-to-r from-[#5d728c] via-[#4d6278] to-[#5d728c] text-white text-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-center gap-2 sm:gap-3 flex-wrap text-center">
        <Tag className="w-4 h-4 shrink-0" />
        <span className="font-medium">
          Limited Time: <span className="font-semibold">20% OFF</span> your entire order with code
        </span>
        <button
          type="button"
          onClick={handleCopy}
          aria-label="Copy promo code SAVE20"
          className="inline-flex items-center gap-1.5 bg-white/15 hover:bg-white/25 transition-colors border border-white/30 rounded-full px-3 py-0.5 font-mono font-semibold tracking-wider text-white"
        >
          SAVE20
          {copied ? (
            <Check className="w-3.5 h-3.5" />
          ) : (
            <Copy className="w-3.5 h-3.5 opacity-80" />
          )}
        </button>
        <span className="hidden sm:inline text-white/80">— applied at checkout</span>
      </div>
    </div>
  );
}
